import { Component, effect, ElementRef, inject, input, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-response-actions',
  template: '<ng-content />',
  host: {
    '[class.ready]': 'ready()',
    '[class.live]': 'live()',
    '[attr.aria-hidden]': 'ready() ? null : "true"',
    '[attr.inert]': 'ready() ? null : ""',
    'role': 'group',
    'aria-label': 'Response actions',
  },
  styles: [`
    :host { display:flex;align-items:center;gap:8px;min-height:48px;padding:4px;
      flex-shrink:0;max-width:var(--nova-response-width,64rem);box-sizing:border-box;
      visibility:hidden;opacity:0; }
    :host(.ready) { visibility:visible;opacity:1; }
    :host(.ready.live) { animation:actions-arrive 200ms ease-out both; }
    @keyframes actions-arrive { from { opacity:0;transform:translateY(4px); } to { opacity:1;transform:none; } }
    @media(prefers-reduced-motion:reduce) { :host(.ready.live) { animation:none; } }
  `],
})
export class ResponseActionsComponent implements OnDestroy {
  ready = input(false);
  live = input(false);
  private element = inject<ElementRef<HTMLElement>>(ElementRef);
  private frame?: number;

  constructor() {
    effect(() => {
      const ready = this.ready(), live = this.live();
      if (this.frame !== undefined) cancelAnimationFrame(this.frame);
      if (!ready || !live) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = undefined;
        const actions = this.element.nativeElement;
        const viewport = actions.closest<HTMLElement>('.message-viewport');
        if (!viewport || viewport.classList.contains('user-scrolled')) return;
        const row = actions.getBoundingClientRect(), view = viewport.getBoundingClientRect();
        // Reveal a partially visible toolbar, without pulling readers away from earlier text.
        if (row.top >= view.top && row.top < view.bottom && row.bottom > view.bottom - 16) {
          viewport.scrollBy({ top: row.bottom - view.bottom + 16,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      });
    });
  }
  ngOnDestroy() { if (this.frame !== undefined) cancelAnimationFrame(this.frame); }
}
